import {Customer} from "../customer";
import {ShippingRecipient} from "../shipment";
import {Nullable} from "../../../../types";
import {AdminUser} from "../adminUser/adminUser";
import {Organization} from "../organization";

export enum OrderField {
    ID = "id",
    ORDER_NUMBER = "orderNumber",
    LEGACY = "legacy",
    CUSTOMER = "customer",
    CUSTOMER_NAME = "customerName",
    CUSTOMER_NAME_MISMATCH = "customerNameMismatch",
    CUSTOMER_NUMBER = "customerNumber",
    ORGANIZATION = "organization",
    ORGANIZATION_ID = "organizationId",
    SHIPPING_RECIPIENT = "shippingRecipient",
    SHIPPING_RECIPIENT_NAME = "shippingRecipientName",
    ITEMS = "items",
    ADMIN_USER = "adminUser",
    ADMIN_USER_EMAIL = "adminUserEmail",
    STATUS = "status",
    COMMENT = "comment",
    ADMIN_USER_CREATED_AT = "adminUserCreatedAt",
    SHIPMENT_CREATED_AT = "shipmentCreatedAt",
    CANCELED_AT = "canceledAt",
    CANCEL_REASON = "cancelReason",
    UPDATED_AT = "updatedAt",
    CREATED_AT = "createdAt",
    VALIDATION_ERROR = "validationError",
}

export interface Order {
    [OrderField.ID]: number;
    [OrderField.ORDER_NUMBER]: number;
    [OrderField.LEGACY]: boolean;
    [OrderField.CUSTOMER]: Customer;
    [OrderField.ORGANIZATION]: Organization;
    [OrderField.SHIPPING_RECIPIENT]: ShippingRecipient;
    [OrderField.ITEMS]: OrderItem[];
    [OrderField.ADMIN_USER]: AdminUser;
    [OrderField.ADMIN_USER_CREATED_AT]?: string;
    [OrderField.STATUS]: OrderStatus;
    [OrderField.COMMENT]?: string;
    [OrderField.SHIPMENT_CREATED_AT]: string;
    [OrderField.CANCELED_AT]: Nullable<string>;
    [OrderField.CANCEL_REASON]: Nullable<string>;
    [OrderField.UPDATED_AT]: string;
    [OrderField.CREATED_AT]: string;
    [OrderField.VALIDATION_ERROR]?: string;
}

export interface OrderFlat
    extends Pick<
        Order,
        | OrderField.ID
        | OrderField.ORDER_NUMBER
        | OrderField.LEGACY
        | OrderField.ITEMS
        | OrderField.ADMIN_USER_CREATED_AT
        | OrderField.STATUS
        | OrderField.COMMENT
        | OrderField.SHIPMENT_CREATED_AT
        | OrderField.CANCELED_AT
        | OrderField.CANCEL_REASON
        | OrderField.UPDATED_AT
        | OrderField.CREATED_AT
    > {
    [OrderField.CUSTOMER_NAME]: string;
    [OrderField.CUSTOMER_NAME_MISMATCH]: boolean;
    [OrderField.CUSTOMER_NUMBER]: string;
    [OrderField.ORGANIZATION_ID]: Nullable<number>;
    [OrderField.SHIPPING_RECIPIENT_NAME]: string;
    [OrderField.ADMIN_USER_EMAIL]: string;
    [OrderField.ADMIN_USER_CREATED_AT]?: string;
    [OrderField.VALIDATION_ERROR]?: string;
}

export enum OrderItemField {
    LEO_ID = "leoId",
    TYPE = "type",
    CONNECTION_TYPE = "connectionType",
    BRANDING = "branding",
    ALREADY_HANDED_OUT = "alreadyHandedOut",
    SERIAL_NUMBER = "serialNumber",
}

export interface OrderItem {
    [OrderItemField.LEO_ID]: string;
    [OrderItemField.TYPE]: ItemType | string;
    [OrderItemField.CONNECTION_TYPE]: ItemConnectionType | string;
    [OrderItemField.BRANDING]: ItemBranding | string;
    [OrderItemField.ALREADY_HANDED_OUT]: boolean;
    [OrderItemField.SERIAL_NUMBER]: string;
}

export enum OrderStatus {
    NEW = "NEW",
    CANCELED = "CANCELED",
    SHIPMENT_CREATED = "SHIPMENT_CREATED",
}

export enum ItemType {
    TRUCK = "TRUCK",
    CAR = "CAR",
    BUS = "BUS",
    TRAILER = "TRAILER",
}

export enum ItemBranding {
    DKV_DEFAULT = "DKV_DEFAULT",
    NO_BRANDING = "NO_BRANDING",
    RESELLER_0001 = "RESELLER_0001",
    RESELLER_0002 = "RESELLER_0002",
}

export enum ItemConnectionType {
    FMS = "FMS",
    CANCEL = "CANCEL",
    EBS_WABCO = "EBS_WABCO",
    EBS_KNORR = "EBS_KNORR",
    CANCL_RDL_INV = "CANCL_RDL_INV",
    OBD2 = "OBD2",
    UNKNOWN = "UNKNOWN",
    N_A = "N/A",
}
